import styled from 'styled-components'

const StyledIcon = styled.svg`
  width: 1em;
  height: 1em;
  fill: ${(props: any) => props.fill};
  stroke: ${(props: any) => props.stroke};
  cursor: ${(props: any) => (props.onClick ? 'pointer' : 'initial')};
`

interface IconProps {
  className?: string
  fill?: string
  name: string
  onClick?(...args: unknown[]): unknown
  stroke?: string
  title?: string
}

export default function Icon({ name, fill, stroke, className, title, onClick }: IconProps) {
  return (
    // @ts-expect-error
    <StyledIcon className={className} fill={fill} stroke={stroke} onClick={onClick} title={title || name}>
      <use xlinkHref={`#${name}`} />
    </StyledIcon>
  )
}
